import { Component, OnInit } from '@angular/core';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';

@Component({
  selector: 'app-sportsnav',
  templateUrl: './sportsnav.component.html',
  styleUrls: ['./sportsnav.component.css']
})
export class SportsnavComponent extends BaseClass<any> implements OnInit {

  public menu: any[] = [];
  constructor(
    public service: WebserviceService,
    private _shared: SharedService
  ) { super();
    const sub3 = this._shared.sharedSideMenu.subscribe((data: any) => {
      //console.log("kkkk");
      //console.log(data);
      if (data && data?.menuAPICall) {
        this.menu = this.getLocalItem('menu');
      }

    });
    this.subs.push(sub3); }

  ngOnInit(): void {
    this.menu = (localStorage.getItem(`${this.env.panel}menu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}menu`) as any) : [];
    if (this.menu.length == 0) {
      this.getMenu(); console.log("innn");
    }
  }

  getMenu() {
    this.getServices().Get(`${this.env.baseUrl + this.api.menu}`).subscribe(
      (res) => {

        if (res && res.status == true) {
          if (!localStorage.getItem(`${this.env.panel}stakes`)) {
            localStorage.removeItem(`${this.env.panel}stakes`);
            localStorage.setItem(`${this.env.panel}stakes`, JSON.stringify(this.env.stakes));
          }
          this.array_move(res?.data?.menu);
          localStorage.removeItem(`${this.env.panel}menu`);
          localStorage.setItem(`${this.env.panel}menu`, JSON.stringify(res?.data?.menu));
          this.menu = res?.data?.menu;
          this._shared.emitSideMenu({ menuAPICall: true });
        }
      },
      (err) => {
        console.log(err);
      });
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

}
